interface ItemsToScrollForwardParams {
    /** Индекс текущего слайда */
    currentSlideIndex: number;
    /** Всего слайдов */
    itemsLength: number;
    /** На сколько слайдов сдвигать по умолчанию */
    itemsToScroll: number;
}

/**
 * Расчитывает на сколько слайдов еще можно сдвинуться вперед
 */
export const useItemsToScrollForward = function (params: ItemsToScrollForwardParams) {
    const { currentSlideIndex, itemsLength, itemsToScroll } = params;
    const itemsToScrollForward = itemsLength - currentSlideIndex - 1;

    return Math.min(itemsToScrollForward, itemsToScroll);
};
